import axios from '../../service/index'
import React from 'react'
import { Button, Upload, message, Modal,Input } from 'antd'
const { TextArea } = Input;
// const qiniuUpUrl = window.location.protocol === "https:" ? 'https://up-z1.qiniup.com' : 'http://up-z1.qiniup.com/';
const qiniuUpUrl = 'https://up-z1.qiniup.com'
class batchUploadQiniu extends React.Component {
	constructor(props) {
		super(props)
		let fileList = []
		let uploadUrl = null
		let proposalSize = ''
		let limit = 1
		let accept = ".png,.jpg,.jpeg"
		// console.log(props, 2)
		if (props.value) {
			fileList = props.value || []
			// uploadUrl = props.value.url || ''
			limit = props.value.limit
		}
		if(props.limit){
			limit = props.limit
		}
		
		if (props.id === 'uploadUrls') {
			// proposalSize = '仅支持jpg/png/jpeg文件，且不超过2M，建议尺寸：68*68px'
			proposalSize = '为了保证显示效果，请上传 140 x 140 大小的图标，支持jpg、jpeg、png格式，文件大小不超过 2M'
		}
		if(props.id === 'images'){
			proposalSize = '支持jpg、jpeg、png格式，文件大小不超过 2M，且最多支持上传8张;'
		}
		this.state = {
			visible: false,
			bosObj: null,
			fileType: 'limit',
			scriptStatus: 'no',
			fileList: fileList,
			limit: limit,
			token: '',
			url: '',
			uploadUrl: uploadUrl,
			previewVisible: false,
			type: '',
			proposalSize: proposalSize,
			accept: accept,
		}
	}
	handleOk() {
		this.setState({ visible: false })
	}
	componentDidMount() {
		this.getToken()
	}
	static getDerivedStateFromProps(nextProps, prevState) {
		if (prevState.fileList.length<=0&&nextProps.value.length>0) {
			let fileList = []
			let uploadUrl = ''
			fileList = nextProps.value || []
			// uploadUrl = nextProps.value[0]?.url || ''
			// multiple = nextProps.value?.multiple||false
			// this.setState({fileList, uploadUrl})
			return { fileList, uploadUrl}
		}
		return null;
	}
	getToken() {
		let _this = this;
		axios.get("/uplodController/get7menrToken").then((res) => {
			if (res.data.code === '200') {
				_this.setState({
					token: res.data.data.token,
					url: res.data.data.url
				})
				// this.props.getQiniuUrl(res.data.data.url)
			} else {
				message.error('七牛token获取失败')
			}

		}).catch((e) => {
			console.log(e)
		})
	}
	handlePreview = async file => {
		this.setState({
			previewVisible: true,
			uploadUrl: file.url,
		});
	}
	removeFileList = () => {
    this.setState({
      uploadUrl: "",
    });
    this.setState({ fileList: [] }, () => {
    });
  };
	handleChange = ({ file, fileList }) => {
		// console.log(file)
		if (file.percent === 100) {
			if (file.status === 'done') {

				file.type = this.state.type
				this.setState({
					uploadUrl: this.state.url + '/' + file.response.key
				})
				// console.log(fileList)
				let newFile = []
				fileList.map(v=> {
					if(v.response||v.url){
						let fileL = {
							uid: v.uid,
							name: v.name,
							status: v.status,
							url: v.url?v.url:v.response?(this.state.url + '/' + v.response.hash):'',
							type: v.type
						}
						newFile.push(fileL)
					}
					return newFile
				})
				// this.setState({ fileList: [fileL] });
				this.setState({ fileList: [...newFile] });
				// this.props.onChange(file)
				this.props.onChange(newFile)
			}
		}
		else if (file.status === 'removed') {
			const newIndex = this.state.fileList.filter(item => item.url !== file.url)
							this.setState({fileList: newIndex},()=> {
								this.props.onChange(newIndex)
							})
			// console.log(this.state.fileList)
		}
	};
	showModal() {
		this.setState({ visible: true })
	}
	handleCancel = () => this.setState({ previewVisible: false, uploadUrl: '' });
	render() {
		const { fileList, previewVisible, uploadUrl, accept } = this.state;
		const uploadButton = (
			<div>
				<Button>上传</Button>
			</div>
		);
		return (
			<div>
				<Upload
					accept={accept}
					action={qiniuUpUrl}
					fileList={fileList}
					listType='picture'
					beforeUpload={(file, fileList) => {
						if(this.state.limit>1&&fileList.length>this.state.limit)
						this.setState({ type: file.type })
						const isLt10M = file.size / 1024 / 1024 <= 2;
						if (!isLt10M) {
							message.error("文件大小限制在2M以下！");
							return false;
						}
						this.setState({ fileList: [...fileList, ...this.state.fileList] })
					}}

					onPreview={this.handlePreview}
					onChange={this.handleChange}
					onRemove={(file, fileList) => {
						this.setState({
							uploadUrl:""
						})
						const newIndex = this.state.fileList.filter(item => item.url !== file.url)
						// if (file.status === "removed") {
							// console.log('removed2')
							this.setState({fileList: newIndex},()=> {
								// this.props.onChange()
								this.props.onChange(newIndex)
							})
							// }
						
					}}
					data={{ token: this.state.token }}
				>
					{this.state.fileList.length >= this.state.limit ? '' : uploadButton}
					
				</Upload>
				<p style={{ fontSize: '12px', color: '#999999' }}>{this.state.proposalSize}</p>
				<Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
					<img alt="example" style={{ width: '100%' }} src={uploadUrl} />
				</Modal>
				{ this.props.isURL ? <TextArea autoSize value={uploadUrl}/> : "" }
			</div>
		)
	}
}

export default batchUploadQiniu
